export default __webpack_public_path__ + "static/media/partly-cloudy-night.11baf666.svg";